import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { ShopManagerInfo } from 'actions/actionTypes';
import * as actions from 'actions/shop/shopManagerInfo';
import { callShoManagerInfo, callEditShoManagerInfo } from 'network/apis/shop/shopManagerInfo';

// 매장 직원 정보 조회 사가 함수
function* loadShopManagerInfoRequestSaga() {
    try {
        const shopManagerInfo = yield select(state => state.shopManagerInfo);

        const response = yield call(callShoManagerInfo, shopManagerInfo.data.managerIdx);

        yield put(actions.loadShopManagerInfoRequestSuccess(response.data));
    } catch(error) {
        console.error(error);
        yield put(actions.loadShopManagerInfoRequestFailure(error.message));
    }
}

// 매장 직원 정보 수정 사가 함수
function* editShopManagerInfoRequestSaga(action) {
    try {
        // 액션에서 전달된 password 값을 사용
        const { newPassword } = action.payload;
        // const shopManagerInfo = yield select(state => state.shopManagerInfo);

        // axios 등을 사용할 때 JSON으로 보냄(Content-Type: application/json)
        const data ={
            newPassword: newPassword, // 액션에서 받은 password
        };
        
        const response = yield call(callEditShoManagerInfo, data);

        // 응답 상태가 200일 경우 성공 처리
        if (response.status === 200) {
            yield put(actions.editShopManagerInfoRequestSuccess(response.data));
        } else {
            yield put(actions.editShopManagerInfoRequestFailure('Failed to manager information')); // 실패 액션 디스패치
        }
        
        // 수정 후 매장 직원 정보를 다시 로드 (필요할 경우)
        yield put(actions.loadShopManagerInfoRequest());
    } catch(error) {
        console.error('Error in Saga:', error);
        yield call(() => alert("Fail"));
        yield put(actions.editShopManagerInfoRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(ShopManagerInfo.LOAD_SHOP_MANAGER_INFO_REQUEST, loadShopManagerInfoRequestSaga),
        takeLatest(ShopManagerInfo.EDIT_SHOP_MANAGER_INFO_REQUEST, editShopManagerInfoRequestSaga),
    ]);
}